import { defineMessages, injectIntl } from "react-intl"
import { Intl } from "../../state/helpers/IntlProps"
import moment from "moment"

const messages = defineMessages({
    "duration_total": {
        id: "duration_total",
        defaultMessage: "{nbDays}{nbHour}{nbMin}",
    },
    "duration_days": {
        id: "duration_days",
        defaultMessage: "{days}d "
    },
    "duration_hours": {
        id: "duration_hours",
        defaultMessage: "{hours}h "
    },
    "duration_minutes": {
        id: "duration_minutes",
        defaultMessage: "{mins}m"
    },
})
class DurationHelper {
    static calculateDuration(intl: Intl, duration: number, durationInSeconds: number): string {
        let m = 0
        let h = 0
        let d = 0

        if (duration) {
            const eventDuration = moment.duration(duration, "minutes")
            m = Math.floor((eventDuration.asMilliseconds() / 1000 / 60) % 60)
            h = Math.floor((eventDuration.asMilliseconds() / (1000 * 60 * 60)) % 24)
            d = Math.floor(eventDuration.asMilliseconds() / (1000 * 60 * 60 * 24))
        } else if (durationInSeconds) {
            m = Math.floor(durationInSeconds % 3600 / 60)
            h = Math.floor(durationInSeconds / 3600)
        } else {
            return ""
        }


        return intl.formatMessage(messages["duration_total"], {
            nbDays: d > 0 ? intl.formatMessage(messages["duration_days"], {
                days: d
            }) : "",
            nbHour: h > 0 ? intl.formatMessage(messages["duration_hours"], {
                hours: h
            }) : "",
            nbMin: m > 0 ? intl.formatMessage(messages["duration_minutes"], {
                mins: m
            }) : "",
        })
    }

}


export default injectIntl(DurationHelper)


// WEBPACK FOOTER //
// ./src/common/date/DurationHelper.ts